// const BASE_URL = "https://vclive.prod-rasiinfotech.in";
// const BASE_URL = "https://billing.avmjewellers.com";
const BASE_URL = "https://zinger.prod-rasiinfotech.in";
const WEB_URL  = "https://avm.prod-rasiinfotech.in";

// const BASE_URL = "https://billing.eswarjewellers.com";


export { BASE_URL , WEB_URL};